<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProducts()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-apps
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Products
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTaxRates()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-chart-box-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Tax Rates
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrganizationsTransaction()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Transactions
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getWebhooksList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-multiple
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Webhooks
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getAiCredits()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-robot-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              AI Credits
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-credit-card-check
                </v-icon>
              </v-list-item-icon>
              Payments
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getProducts()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-apps
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Products
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getTaxRates()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-chart-box-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Tax Rates
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrganizationsTransaction()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-clock-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Transactions
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getWebhooksList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-clipboard-text-multiple
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Webhooks
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getAiCredits()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-robot-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              AI Credits
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div>
      <products v-if="showProducts" />
      <tax-rates v-if="showTaxRates" />
      <organizations-transaction-list v-if="showOrganizationsTransactionList" />
      <webhooks-list v-if="showWebhooksList" />
      <ai-credits v-if="showAiCredits" />
    </div>
  </v-container>
</template>
<script>
  import Products from 'src/views/dashboard/payments/Products.vue';
  import TaxRates from 'src/views/dashboard/payments/TaxRates/TaxRates.vue';
  import OrganizationsTransactionList from 'src/views/dashboard/payments/OrganizationsTransactionList.vue';
  import WebhooksList from 'src/views/dashboard/payments/webhooks/WebhooksList.vue';
  import AiCredits from 'src/views/dashboard/payments/AiCredits/AiCredits.vue';

  export default {
    name: 'Payments',
    components: {
      Products,
      'tax-rates': TaxRates,
      'organizations-transaction-list': OrganizationsTransactionList,
      'webhooks-list': WebhooksList,
      'ai-credits': AiCredits,
    },
    data: () => ({
      selectedItem: -1,
      showProducts: true,
      showTaxRates: false,
      showOrganizationsTransactionList: false,
      showWebhooksList: false,
      showAiCredits: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getProducts () {
        this.showTaxRates = false;
        this.showOrganizationsTransactionList = false;
        this.showWebhooksList = false;
        this.showAiCredits = false;
        this.showProducts = true;
      },
      getTaxRates () {
        this.showProducts = false;
        this.showOrganizationsTransactionList = false;
        this.showWebhooksList = false;
        this.showAiCredits = false;
        this.showTaxRates = true;
      },
      getOrganizationsTransaction () {
        this.showProducts = false;
        this.showTaxRates = false;
        this.showWebhooksList = false;
        this.showAiCredits = false;
        this.showOrganizationsTransactionList = true;
      },
      getWebhooksList () {
        this.showProducts = false;
        this.showTaxRates = false;
        this.showOrganizationsTransactionList = false;
        this.showAiCredits = false;
        this.showWebhooksList = true;
      },
      getAiCredits () {
        this.showProducts = false;
        this.showTaxRates = false;
        this.showOrganizationsTransactionList = false;
        this.showWebhooksList = false;
        this.showAiCredits = true;
      },
    },
  };
</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
</style>
